import { jsx as _jsx } from "react/jsx-runtime";
import { useFocusVisible } from "use-focus-visible";
import { getPathValue, isRenderCell, validateValue } from "../util";
import { StyledTableHeaderCell } from "./styledtablecell.styles";
export function HeaderCell({ record, dataIndex, render, additionalProps, index, children, colSpan, sortOrder, sortIcon, align = "left", width = "auto", font, tableType, disabled, readonly, }) {
    const { focusVisible, onFocus, onBlur } = useFocusVisible();
    let cellProps;
    let childNode;
    if (validateValue(children)) {
        childNode = children;
    }
    else {
        const value = getPathValue(record, dataIndex);
        childNode = value;
        if (render) {
            const renderData = render(value, record, index);
            if (isRenderCell(renderData)) {
                childNode = renderData.children;
                cellProps = renderData.props;
            }
            else {
                childNode = renderData;
            }
        }
    }
    const Indicator = sortOrder === "ascend" ? "▲" : "▼";
    const elements = [childNode];
    if (sortIcon) {
        elements.push(_jsx("span", Object.assign({ className: "sort-icon" }, { children: Indicator }), "indicator"));
    }
    if (align === "right") {
        elements.reverse();
    }
    return (_jsx(StyledTableHeaderCell, Object.assign({ className: `${disabled ? "disabled" : ""} ${readonly ? "readonly" : ""}`, align: align, font: font, tableType: tableType, focusVisible: sortIcon && focusVisible, sortIcon: sortIcon, width: width || "auto", sortOrder: sortOrder }, additionalProps, cellProps, { colSpan: colSpan, onFocus: onFocus, onBlur: onBlur, tabIndex: sortIcon ? 0 : -1, onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === "Space" || e.key === " ")
                if (additionalProps) {
                    additionalProps.onClick(e);
                }
        } }, { children: elements })));
}
